var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#47494A",
    stroke: "#47494A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:none;stroke:#47494A;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m40.5,5.5H7.5c-1.1,0-2,.9-2,2v33c0,1.1.9,2,2,2h33c1.1,0,2-.9,2-2V7.5c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "31.1909 19.7988 27.8429 27.7988 24.4949 19.7988"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "31.5332 26.2012 34.8812 18.2012 38.2292 26.2012"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m20.6829,23.7988c1.1046,0,2,.8954,2,2s-.8954,2-2,2h-3.3v-8h3.3c1.1046,0,2,.8954,2,2s-.8954,2-2,2h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 20.6829,
    y1: 23.7988,
    x2: 17.3829,
    y2: 23.7988
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m13.0708,23.7988c1.1046,0,2,.8954,2,2s-.8954,2-2,2h-3.3v-8h3.3c1.1046,0,2,.8954,2,2s-.8954,2-2,2h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 13.0708,
    y1: 23.7988,
    x2: 9.7708,
    y2: 23.7988
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbva);
export default __webpack_public_path__ + "static/media/bbva.529679d1b2f9996d2e937c30100acdd1.svg";
export { ForwardRef as ReactComponent };